import moment from 'moment';

/**
 * Renders a date in normal language
 * @param value
 * @returns {string}
 */
export default function (value, limitType = 'months', limitAmount = 3) {

    if ( !value ) return 'NON';

    let mom;
    if ( typeof value === 'object' ) {
        mom = value;
    } else {
        mom = moment(value);
    }

    if ( !mom.isValid() ) return '??';

    // need dates for checking with
    const now = Date.now();

    let ret;

    if ( mom.isBefore(now) ) {

        // let hours = moment(now).subtract(12, 'hours');
        let week = moment(now).startOf('day').subtract(7, 'days');

        if ( mom.isBefore(week) ) {
            ret = mom.format('llll')
        } else  {
            ret = mom.fromNow();
        }

    } else {

        let months = moment(now).startOf('day').add(limitAmount, limitType);

        if ( mom.isAfter(months) ) {
            ret = mom.format('ll');
        } else {
            ret = moment(value).fromNow();
        }
    }

    return ret;
}
